import * as React from "react";
import I18n from "i18n";
import * as jQuery from "jquery";
import * as _ from "underscore";
import Spinner from './Spinner'
import dayjs from 'libraries/dayjs'
import {
  IKbApiEntity, IKbApiRepType, IKbApiRepresentation, findRepresentation,
  SupportedLocale, localizedName, locale
} from 'models/kbApiEntity'
import { EntityDetailViewContainer as Container } from 'components/entityDetailViewContainer'

export interface Props {
  law?: IKbApiEntity
}
export class LawDetailView extends React.Component<Props, {}> {
  render() {
    if (this.props.law) {
      const law = this.props.law
      const name = localizedName(law)
      return (
        <Container>
          {this.updatedAt()}
          <h2 className="heading-xlarge mtm">{name}</h2>
          {this.lawMarkup()}
        </Container>
      )
    } else {
      const label = I18n.t('webapp.components.lawDetailView.loading')
      return (
        <Container> <Spinner label={label} /> </Container>
      )
    }
  }
  private lawMarkup() {
    const supportedLocales: SupportedLocale[] = ['de', 'fr', 'it', 'en']
    return supportedLocales.map((locale)=> {
      const name = findRepresentation(this.law(), 'name', locale)
      const label = I18n.t('webapp.components.lawDetailView.name_' + locale)
        if (name != undefined) {
          return (
            <form className="form-item mvm">
              <label className="form-item__label">{label}</label>
              <div className="form-item__input">
                <input type="text" className="text-input text-input--block" disabled={true} value={name}/>
              </div>
            </form>
          )
        }

    })
  }

  private law(): IKbApiEntity {
    if (this.props.law != undefined) {
      return this.props.law
    } else {
      throw "law is undefined"
    }
  }

  private updatedAt() {
    const updatedAt = this.law().data.attributes.updated_at
    const fmt = dayjs(updatedAt).format("DD.MM.YYYY HH:mm")
    return (
      <div className="link-bar mbm">
        <span className="link-bar__right-item text--grey"> <i className="fa fa-refresh text--white"></i> {fmt}</span>
      </div>
    )
  }
}
